module.exports = __webpack_public_path__ + "static/ankit-85cdf198c4f0daa344d6d76a6d2862ca.jpg";